export enum PipeEnum {
  CurrencyFormat = 'currencyFormat',
  Currency = 'currency',
  Toggle = 'toggle',
  Checkbox = 'checkbox',
  Status = 'status',
  Date = 'date',
  Badget = 'badget',
}